module.exports = __webpack_public_path__ + "img/te-37.da6ef893.png";